module.exports = __webpack_public_path__ + "img/puma.119e40dc.png";